export const changeMenuStatus = (status) => {
  return {
    type: 'CHANGE_MENU_STATUS',
    payload: !status
  }
}

export const changeNavBarInlineStatus = (status) => {
  return {
    type: 'CHANGE_NAVBAR_INLINE_STATUS',
    payload: !status
  }
}

export const changeTheme = (theme) => {
  return {
    type: 'CHANGE_THEME',
    payload: theme
  }
}

export const setuserStateReducer = (data) => {
  return {
    type: 'SET_USERSTATE',
    payload: data
  }
}